<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "Set New Password" | transloco }}</span>
        <h2 class="bb-page-title">{{ "Set New Password" | transloco }}</h2>
      </div>
    </header>

    <form class="bb-card bb-p-20" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
      <div class="bb-form-grid">

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="oldPassword">{{ "Old Password" | transloco }}</label>
          <input
            class="bb-input"
            id="oldPassword"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="old_password"
            placeholder="{{ 'Old Password' | transloco }}"
            [ngClass]="{
              'is-invalid': changePasswordForm.controls['old_password'].touched && changePasswordForm.controls['old_password'].errors,
              'is-valid': changePasswordForm.controls['old_password'].touched && changePasswordForm.controls['old_password'].errors == null,
              'is-touched': changePasswordForm.controls['old_password'].untouched && changePasswordForm.controls['old_password'].errors == null,
            }"
          />
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="Password">{{ "Password" | transloco }}</label>
          <input
            class="bb-input"
            id="Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password"
            placeholder="{{ 'Password' | transloco }}"
            [ngClass]="{
              'is-invalid': changePasswordForm.controls['new_password'].touched && changePasswordForm.controls['new_password'].errors,
              'is-valid': changePasswordForm.controls['new_password'].touched && changePasswordForm.controls['new_password'].errors == null,
              'is-touched': changePasswordForm.controls['new_password'].untouched && changePasswordForm.controls['new_password'].errors == null,
            }"
          />
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="confirmPassword">{{ "Confirm Password" | transloco }}</label>
          <input
            class="bb-input"
            id="confirmPassword"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password_confirmation"
            placeholder="{{ 'Confirm Password' | transloco }}"
            [ngClass]="{
              'is-invalid': changePasswordForm.controls['new_password_confirmation'].touched && changePasswordForm.controls['new_password_confirmation'].errors,
              'is-valid': changePasswordForm.controls['new_password_confirmation'].touched && changePasswordForm.controls['new_password_confirmation'].errors == null,
              'is-touched': changePasswordForm.controls['new_password_confirmation'].untouched && changePasswordForm.controls['new_password_confirmation'].errors == null,
            }"
          />

          <button type="button" class="bb-btn bb-btn-secondary bb-w-100 bb-mt-12" (click)="togglePasswordVisibility()">
            @if(!isPasswordVisible){ {{ "Show Password" | transloco }} } @else { {{ "Hide Password" | transloco }} }
          </button>
        </div>

        <div class="bb-field bb-field-full bb-mt-8">
          <button type="submit" class="bb-btn bb-btn-primary bb-w-100">
            {{ "Send" | transloco }}
          </button>
        </div>

      </div>
    </form>

  </div>
</section>